import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

//const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
const API_URL = process.env.REACT_APP_API_URL;
console.log("Redux slices - API_URL:", API_URL);

const getToken = () => {
  const token = localStorage.getItem("token");
  console.log("Redux slices - Token disponible:", !!token);
  return token;
};

export const fetchMovies = createAsyncThunk(
  "movies/fetchMovies",
  async (_, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await axios.get(`${API_URL}/api/v1/movies`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue("Error fetching movies");
    }
  }
);

export const addMovie = createAsyncThunk(
  "movies/addMovie",
  async ({ movieData, token }, { rejectWithValue }) => {
    try {
      // Si no hay token en los parámetros, intentar obtenerlo del localStorage
      const authToken = token || getToken();
      
      console.log("Sending movie data:", movieData);
      console.log("Using API URL:", `${API_URL}/api/v1/movies`);
      
      const response = await axios.post(`${API_URL}/api/v1/movies`, movieData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
      });
      
      console.log("Response from server:", response.data);
      
      return response.data;
    } catch (err) {
      console.error("Error in addMovie:", err.response || err);
      return rejectWithValue(
        err.response?.data?.message || "Error adding movie"
      );
    }
  }
);

export const updateMovie = createAsyncThunk(
  "movies/updateMovie",
  async ({ id, movieData }, { rejectWithValue, dispatch }) => {
    try {
      // Optimistically update the movie in the Redux store
      dispatch(optimisticUpdateMovie({ id, movieData }));

      const token = getToken();
      const response = await axios.put(
        `${API_URL}/api/v1/movies/${id}`,
        movieData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error updating movie"
      );
    }
  }
);

export const deleteMovie = createAsyncThunk(
  "movies/deleteMovie",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await axios.delete(`${API_URL}/api/v1/movies/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error deleting movie"
      );
    }
  }
);

// Updated to be inside the reducers section
const moviesSlice = createSlice({
  name: "movies",
  initialState: {
    movies: [],
    loading: false,
    error: null,
  },
  reducers: {
    optimisticUpdateMovie: (state, action) => {
      const { id, movieData } = action.payload;
      const index = state.movies.findIndex((movie) => movie.id === id);
      if (index !== -1) {
        state.movies[index] = { ...state.movies[index], ...movieData };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMovies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMovies.fulfilled, (state, action) => {
        state.loading = false;
        state.movies = action.payload;
      })
      .addCase(fetchMovies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addMovie.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMovie.fulfilled, (state, action) => {
        state.loading = false;
        // El backend devuelve { message: "Movie created successfully", movie: {...} }
        // Necesitamos agregar la película, no todo el payload
        if (action.payload && action.payload.movie) {
          state.movies.push(action.payload.movie);
        }
      })
      .addCase(addMovie.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateMovie.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMovie.fulfilled, (state, action) => {
        state.loading = false;
        // No need to do anything here, as it's already updated optimistically
      })
      .addCase(updateMovie.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteMovie.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMovie.fulfilled, (state, action) => {
        state.loading = false;
        state.movies = state.movies.filter(
          (movie) => movie.id !== action.payload
        );
      })
      .addCase(deleteMovie.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { optimisticUpdateMovie } = moviesSlice.actions;

export default moviesSlice.reducer;
